import styles from "@styles/category-icons.module.scss";
import { useEffect, useState } from "react";
import { InputSearch } from "shared/components/InputSearch";
import { categoryIcons } from "./SelectIconCategory";

import { Button } from "@components";
import classNames from "classnames/bind";
const css = classNames.bind(styles);

export default function CategoryIcons({ selectedIcon, onSelectIcon, onClose }) {
  const [occurrences, setOccurrences] = useState(null);
  const [icons, setIcons] = useState(categoryIcons);
  const [icon, setIcon] = useState(null);

  useEffect(() => {
    setIcon(selectedIcon);
  }, [selectedIcon]);

  const searchCategory = (e) => {
    const searchTerm = (e.target.value || "").toLowerCase();

    if (searchTerm.length > 1) {
      const filteredIcons = categoryIcons.filter(
        (icon) => (icon.name || "").toLowerCase().indexOf(searchTerm) > -1
      );

      setOccurrences(filteredIcons.length);
      setIcons(filteredIcons);
    } else {
      setOccurrences(null);
      setIcons(categoryIcons);
    }
  };

  return (
    <>
      <InputSearch
        placeholder="Buscar por..."
        design="two"
        occurrences={occurrences || null}
        onChange={(e) => searchCategory(e)}
        className="mb-20"
      />

      <div className={styles.scrollContainer}>
        <div className={styles.categoryIcons}>
          {icons.map((item) => {
            const iconName = item.icon.props.name;

            return (
              <div
                className={css({
                  icon: true,
                  selected: iconName === icon,
                })}
                onClick={() => setIcon(iconName)}
              >
                {item.icon}
              </div>
            );
          })}
        </div>
      </div>

      <div className={styles.footer}>
        <Button
          className="mb-10"
          design="primary"
          onClick={() => onSelectIcon(icon)}
          disabled={!icon}
        >
          Selecionar ícone
        </Button>
        <Button
          design="default"
          onClick={() => {
            setIcon(null);
            onSelectIcon(null);
            onClose();
          }}
        >
          Continuar sem ícone
        </Button>
      </div>
    </>
  );
}
